var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=index.es228.js.map
